<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">周边游订单履约</h2>
      </div>
      <div class="life-filter">
        <el-input v-model="filters.orderId" placeholder="订单号" clearable style="width: 160px" />
        <el-input v-model="filters.contactPhone" placeholder="手机号" clearable style="width: 140px" />
        <el-input v-model="filters.productName" placeholder="商品名称" clearable style="width: 160px" />
        <el-date-picker
          v-model="departureRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="出发开始"
          end-placeholder="出发结束"
          style="width: 340px"
        />
        <el-select v-model="filters.orderStatus" placeholder="业务状态" clearable style="width: 140px">
          <el-option v-for="item in orderStatuses" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="filters.payStatus" placeholder="支付状态" clearable style="width: 120px">
          <el-option label="未支付" value="UNPAID" />
          <el-option label="已支付" value="PAID" />
          <el-option label="支付异常" value="PAYMENT_EXCEPTION" />
        </el-select>
        <el-select v-model="filters.refundStatus" placeholder="退款状态" clearable style="width: 120px">
          <el-option label="无" value="NONE" />
          <el-option label="已申请" value="REQUESTED" />
          <el-option label="处理中" value="PROCESSING" />
          <el-option label="成功" value="SUCCESS" />
          <el-option label="失败" value="FAILED" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="orderId" label="订单号" min-width="150" />
        <el-table-column prop="productNameSnapshot" label="商品" min-width="140" />
        <el-table-column prop="departureTimeSnapshot" label="出发日期" width="160" />
        <el-table-column prop="travelerCount" label="人数" width="70" align="center" />
        <el-table-column label="订单金额" width="100" align="center">
          <template slot-scope="scope">{{ fenToYuan(scope.row.totalAmountFen) }}</template>
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" width="90" />
        <el-table-column prop="contactPhoneMask" label="手机号" width="120" />
        <el-table-column prop="payStatus" label="支付状态" width="100" />
        <el-table-column prop="orderStatus" label="业务状态" width="110" />
        <el-table-column prop="refundStatus" label="退款状态" width="100" />
        <el-table-column prop="createTime" label="下单时间" width="170" />
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="life-pagination"
        :current-page.sync="page.current"
        :page-size="page.size"
        :page-sizes="[10, 20, 50]"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize"
        @current-change="load"
      />
    </section>
  </div>
</template>

<script>
import { listOrders } from '@/api/travel/travelApi'

export default {
  name: 'TravelOrderList',
  data() {
    return {
      loading: false,
      rows: [],
      departureRange: [],
      filters: {
        orderId: '',
        contactPhone: '',
        productName: '',
        orderStatus: '',
        payStatus: '',
        refundStatus: ''
      },
      page: { current: 1, size: 10, total: 0 },
      orderStatuses: [
        { label: '待支付', value: 'PENDING_PAYMENT' },
        { label: '待出行', value: 'BOOKED' },
        { label: '已核销', value: 'VERIFIED' },
        { label: '已完成', value: 'COMPLETED' },
        { label: '已取消', value: 'CANCELLED' },
        { label: '退款中', value: 'REFUNDING' },
        { label: '已退款', value: 'REFUNDED' },
        { label: '退款失败', value: 'REFUND_FAILED' }
      ]
    }
  },
  created() {
    if (this.$route.query.productName) {
      this.filters.productName = this.$route.query.productName
    }
    this.load()
  },
  methods: {
    fenToYuan(fen) {
      if (fen === null || fen === undefined || fen === '') return '-'
      return (Number(fen) / 100).toFixed(2)
    },
    search() {
      this.page.current = 1
      this.load()
    },
    reset() {
      this.filters = {
        orderId: '',
        contactPhone: '',
        productName: '',
        orderStatus: '',
        payStatus: '',
        refundStatus: ''
      }
      this.departureRange = []
      this.search()
    },
    changeSize(size) {
      this.page.size = size
      this.page.current = 1
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const params = {
          ...this.filters,
          page: this.page.current,
          row: this.page.size
        }
        if (this.departureRange && this.departureRange.length === 2) {
          params.departureStart = this.departureRange[0]
          params.departureEnd = this.departureRange[1]
        }
        const res = await listOrders(params)
        this.rows = res.data || []
        this.page.total = res.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    goDetail(row) {
      this.$router.push({ path: '/travel/orderDetail', query: { orderId: row.orderId } })
    }
  }
}
</script>

<style scoped lang="scss">
@import './life.scss';
</style>
